import createVueComponent from '../createVueComponent';

const Minus = createVueComponent('MinusIcon', [
  ['path', { d: 'M5 12h14', key: '1ays0h' }],
]);

export default Minus;
